var $095537f2cf4c29e4$exports = {};
$095537f2cf4c29e4$exports = {
    "info": `Information`,
    "negative": `Fel`,
    "notice": `Varning`,
    "positive": `Lyckades`
};


export {$095537f2cf4c29e4$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
